import React, { useEffect, useState } from "react";
import { useOrganization } from "../../Utils/OrganizationContext";
import DataTable, { TableColumn } from "react-data-table-component";
import { Link, useNavigate } from "react-router-dom";
import { fetchData } from "../../Utils/OrionList";
import axios from "axios";
import { LOGOUT } from "../../Routes/AppRoutes";
import { ProductColor } from "../../Models/ProductColor";
import { Col, Container, Dropdown, DropdownButton, Row } from "react-bootstrap";
import { Pencil } from "react-bootstrap-icons";
import {
  PRODUCT_COLOR_ADD,
  PRODUCT_COLOR_EDIT,
} from "../../Routes/ProductColorRoutes";
import CustomSkeleton from "../../Components/CustomSkeleton";

interface ProductColorData {
  id: number;
  title: string;
}

const List = () => {
  let { selectedOrganizationId, organizationId }: any = useOrganization();
  let title = "Product Color";
  const [data, setData] = useState<ProductColorData[]>([]);
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [limit, setLimit] = useState(10);
  const navigate = useNavigate();
  const [inputValues] = useState({});
  const [sortField, setSortField] = useState("id");
  const [sortOrder, setSortOrder] = useState("desc");

  const handleRowEditButtonClick = (id: number) => {
    navigate(PRODUCT_COLOR_EDIT.replace(":id", id.toString()));
  };

  const columns: TableColumn<ProductColorData>[] = [
    {
      name: "ID",
      selector: (row) => row.id,
      sortable: true,
      wrap: true,
    },
    {
      name: "Title",
      selector: (row) => row.title,
      sortable: true,
      wrap: true,
    },
    {
      name: "Action",
      cell: (row) => renderActionsDropdown(row),
    },
  ];

  const renderActionsDropdown = (row: any) => (
    <DropdownButton
      className="outline-border"
      id={`dropdown-actions-${row.id}`}
      title="Actions"
      variant="outline-primary"
      size="sm"
    >
      <Dropdown.Item
        eventKey="1"
        onClick={() => handleRowEditButtonClick(row.id)}
      >
        <Pencil /> Edit
      </Dropdown.Item>
    </DropdownButton>
  );

  const fetchProductColor = async (page: number | undefined) => {
    setLoading(true);

    try {
      await fetchData(
        page,
        limit,
        inputValues,
        setLoading,
        setData,
        setTotalRows,
        navigate,
        new ProductColor(),
        sortField,
        sortOrder,
      );
    } catch (error) {
      if (axios.isAxiosError(error)) {
        if (error.response) {
          const statusCode = error.response.status;
          if (statusCode === 401) {
            navigate(LOGOUT);
          }
        } else {
          console.log("An error occurred:", error.message);
        }
      } else {
        console.log("An unknown error occurred:", error);
      }
    }
  };

  const handlePageChange = (page: number | undefined) => {
    fetchProductColor(page);
  };
  const handlePerRowsChange = async (limit: any, page: any) => {
    setLoading(true);
    setLimit(limit);
    setLoading(false);
  };

  useEffect(() => {
    fetchDataWithSorting(1, sortField, sortOrder);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOrganizationId, limit, organizationId]);

  const fetchDataWithSorting = async (
    page: number | undefined,
    sortField: string,
    sortOrder: string,
  ) => {
    setLoading(true);
    try {
      await fetchData(
        page,
        limit,
        inputValues,
        setLoading,
        setData,
        setTotalRows,
        navigate,
        new ProductColor(),
        sortField,
        sortOrder,
      );
    } catch (error) {
      console.error("Failed to fetch product colors with sorting:", error);
    }
  };

  const handleSort = (selectedColumn: any, sortDirection: any) => {
    fetchDataWithSorting(1, selectedColumn["sortField"], sortDirection);
    setSortField(selectedColumn["sortField"]);
    setSortOrder(sortDirection);
  };

  return (
    <>
      <Container fluid>
        <Row className="mt-4">
          <Col>
            <h2>{title} List</h2>
          </Col>
          <Col className="text-md-end">
            <Link to={`${PRODUCT_COLOR_ADD}`}>
              <button className="btn addnew-btn mb-2 btn-sm">
                Add&nbsp;{title}
              </button>
            </Link>
          </Col>
        </Row>
      </Container>
      <DataTable
        columns={columns}
        data={data}
        progressPending={loading}
        pagination
        paginationServer
        paginationTotalRows={totalRows}
        onChangeRowsPerPage={handlePerRowsChange}
        onChangePage={handlePageChange}
        onSort={handleSort}
        noDataComponent={
          <>
            <img src="/images/svg/No_data_available.svg" alt="" />
          </>
        }
        progressComponent={
          <CustomSkeleton
            customInnerStyle={{ marginBottom: "9.5px" }}
            count={totalRows || 10}
            height={36}
          />
        }
      />
    </>
  );
};

export default List;
